import {
  FloatingNode,
  FloatingTree,
  useFloating,
  useFloatingNodeId,
  useFloatingParentNodeId,
} from '@floating-ui/react';
import classNames from 'classnames';
import React from 'react';
import FocalPoint from './focal-point';

interface Props {
  active?: boolean;
  className?: string;
  baseClassName?: string;
  onExit?: (event: React.KeyboardEvent) => void;
  children: React.ReactNode;
  element?: string;
}

const FocusTrap = (props: Props): React.ReactElement => {
  const {
    active = true,
    onExit,
    className,
    baseClassName = 'focus-trap',
    children,
    element,
  } = props;

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      onExit?.(event);
    }
  };

  const nodeId = useFloatingNodeId();
  const parentNodeId = useFloatingParentNodeId();
  useFloating({ nodeId, open: active });

  if (!active) return <>{children}</>;

  const node = (
    <div className={classNames(`${baseClassName}-wrapper`, className)} onKeyDown={handleKeyDown}>
      <FloatingNode id={nodeId}>
        <FocalPoint className={baseClassName} element={element} floatingNodeId={nodeId}>
          {children}
        </FocalPoint>
      </FloatingNode>
    </div>
  );

  return !parentNodeId ? <FloatingTree>{node}</FloatingTree> : node;
};

export default FocusTrap;
